/** Decode canonical API errors without exposing transport or server exception details. */
export interface WorkerRequestFailure {
  code: string
  message: string
  recovery: 'enroll' | 'signin' | 'retry'
}
export function workerRequestFailure(error: unknown): WorkerRequestFailure {
  const response = (error as any)?.response
  const body = response?.data
  const code = typeof (body?.error?.code || body?.code) === 'string' ? body.error?.code || body.code : ''
  const candidate = body?.error?.message || body?.message || (!response && error instanceof Error ? error.message : '')
  const safe = typeof candidate === 'string' && candidate.length <= 500
    && !/(?:\bat\s+\S+\s*\(|\b(?:select|insert|update|delete)\s.+\b(?:from|into|set)\b|stack\s*trace|SQLSTATE|postgres|TypeError|ReferenceError|https?:\/\/)/i.test(candidate)
  const recovery = code === 'mfa_enrollment_required' ? 'enroll'
    : response?.status === 401 || ['mfa_required', 'authentication_assurance_required', 'reauthentication_required', 'mfa_reauthentication_required'].includes(code) ? 'signin' : 'retry'
  return { code, recovery, message: safe && candidate ? candidate : 'Unable to load this section. Please try again.' }
}
